import React from 'react';
import { useTranslation } from "react-i18next";
import { ICON_PATHS } from '../../components/shared-components/icon-paths';

// icon paths for the listing categories, by their name in the config
export const CATEGORY_ICONS = {
    sale: 'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8ZM7.5 7.5h.01',
    rent: 'M14 10a4 4 0 1 0-7.4 2.1L3 15.7V20h4.3l.7-.7V18h1.3l.7-.7V16h1.3l1.6-1.6A4 4 0 0 0 14 10ZM10 9h.01',
    short_term: 'M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M5 7h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1ZM9 11v5M15 11v5',
};

export const CategoryIcon = ({ name, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={CATEGORY_ICONS[name]} /></svg>
);

// icon paths and description keys for the property types, by their id on the server
export const PROPERTY_TYPES = {
    1: { desc: 'house_desc', icon: ICON_PATHS.home },
    2: { desc: 'apartment_desc', icon: 'M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 10h4a1 1 0 0 1 1 1v10M3 21h18M8 8h3M8 12h3M8 16h3' },
    3: { desc: 'garage_desc', icon: ICON_PATHS.garage },
    4: { desc: 'land_desc', icon: 'M3 20h18M5 20l3-9h8l3 9M8 11l1-4h6l1 4M12 7V3M12 3l3 1.5L12 6' },
    5: { desc: 'business_desc', icon: 'M3 21h18M5 21V9h14v12M3 9l2-5h14l2 5M9 21v-5h6v5M8 12h2M14 12h2' },
    6: { desc: 'shop_desc', icon: 'M3 21h18M5 21V10M19 21V10M3 10l2-6h14l2 6H3ZM9 21v-6h6v6' },
    7: { desc: 'office_desc', icon: 'M3 21h18M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2' },
    8: { desc: 'building_desc', icon: 'M3 21h18M4 21V8l5-3v16M9 21V3h11v18M12 7h2M16 7h1M12 11h2M16 11h1M12 15h2M16 15h1' },
    9: { desc: 'hall_desc', icon: 'M2 21h20M3 21V10l9-6 9 6v11M7 21v-7h10v7M7 17h10' },
    10: { desc: 'warehouse_desc', icon: 'M3 21V8l9-5 9 5v13M7 21v-9h10v9M7 15h10M7 18h10' },
    11: { desc: 'raft_desc', icon: 'M3 15h18l-2 4H5l-2-4ZM6 15V9h12v6M9 9V6h6v3M2 21c2 0 2-1 4-1s2 1 4 1 2-1 4-1 2 1 4 1 2-1 4-1' },
};

export const PropertyTypeIcon = ({ id, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={PROPERTY_TYPES[id]?.icon || PROPERTY_TYPES[2].icon} /></svg>
);

const TIPS = [
    { key: 'success_info_1', icon: 'M3 8a2 2 0 0 1 2-2h2l1.5-2h7L17 6h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2ZM12 9.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z' },
    { key: 'success_info_2', icon: 'M4 6h16M4 10h16M4 14h10M4 18h7' },
    { key: 'success_info_3', icon: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2', warn: true },
];

// the three reminders about photos, the description and listings without photos
export const ListingTips = ({ plain }) => {
    const { t } = useTranslation(["listing"]);

    return (
        <div className={`hs-nl-tips ${plain ? 'plain' : ''}`}>
            {TIPS.map(tip => (
                <div key={tip.key} className='hs-nl-tip'>
                    <span className={`hs-nl-tip-icon ${tip.warn ? 'warn' : ''}`}>
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d={tip.icon} /></svg>
                    </span>
                    <span className='hs-nl-tip-text'>{t(`${tip.key}_part_1`)} <strong>{t(`${tip.key}_part_2`)}.</strong></span>
                </div>
            ))}
        </div>
    );
};
